<template>
  <div v-show="p_active" class="c2_2_1">
    <MsgBox v-show="bbMsg" :a-do="p04_doConfirm" :p-msg="errMsg" :p-cancel="ssMsgCancel" :p-ok="ssMsgOk"/>
    <!--查询-->
    <div v-if="!bbFull" class="divSearch">
      <!--finders-->
      <div v-for="(row,idx) in finders" v-show="idx<5 || bbMore" :key="idx" class="divBox">
        <p>{{ row.vlabel }}:</p>
        <input v-if="!row.vfindtype" v-model="searchRow[row.vkey]" :placeholder="row.vhint" class="w120px bdGray">
        <select
          v-if="row.vfindtype>100 && row.vfindtype<200"
          v-model="searchRow[row.vkey]"
          :placeholder="row.vhint"
          class="w120px bdGray">
          <option v-for="(opt,idx) in options['v'+row.vfindtype]" :key="idx" :value="opt">{{ opt }}</option>
        </select>
        <select
          v-if="row.vfindtype>10100 && row.vfindtype<10200"
          v-model="vFilter[row.vkey]"
          :placeholder="row.vhint"
          class="w120px bdGray"><!--@change="p02_filterDs"-->
          <option key="99999" value="">ALL</option>
          <option v-for="(opt,idx) in options['v'+row.vfindtype]" :key="idx" :value="opt">{{ opt }}</option>
        </select>
        <!--dates-->
        <div v-if="comm.numIn(row.vfindtype,[3])" class="spanDate"><!--dates-->
          <el-date-picker
            v-model="searchRow[row.vkey+'1']"
            :clearable="false"
            size="mini"
            type="date"
            class="iptDate"
            value-format="yyyy-MM-dd"
            @input="p91_hChg(3,1,row,$event)"
          />
          <b class="floatL">-</b>
          <el-date-picker
            v-model="searchRow[row.vkey+'2']"
            :clearable="false"
            size="mini"
            type="date"
            class="iptDate"
            value-format="yyyy-MM-dd"
            @input="p91_hChg(3,2,row,$event)"
          />
        </div>
      </div>
      <!--divBts-->
      <div class="divBts">
        <div v-if="!bbReport" class="divW120">
          <input v-model="bbShowAll" type="checkbox" class="iptChk"><p>完整显示</p>
        </div>
        <button @click="toAct(1021)">查询</button>
        <button v-for="btn in btnList" :key="btn.vkey" @click="toAct(btn.vkey)">
          {{ btn.vlabel }}
        </button>
        <a v-if="finders.length>5" @click="toAct(38)">-{{ bbMore?'▲':'更多' }}-</a>
        <i v-if="bbLoading" class="el-icon-loading" style="font-size: 21px;padding: 2px;color:blue;"/>
        <b style="color: white;">{{ iPiy }}</b>
        <!--print-->
        <button v-print="'#divPrtBch'" v-show="false" ref="divPrtBch"/>
        <button v-print="'#divPrt'" v-show="false" ref="divPrt"/>
      </div>
    </div>
    <!--TITLE-->
    <div v-if="bbFull" class="txtC txtB20">{{ p_menu.fnamemenu }}</div>
    <!--列表-->
    <div v-if="bbAdmin || p_menu.fidtype" :style="[{'height':bbFull?'100%':(pHeight-210)+'px'},{'display':(bbBox?'none':'')}]" class="divList">
      <table class="tbList">
        <thead>
          <tr><!-- class="tbListHead"-->
            <th/>
            <th
              v-for="(row,idx) in tbClmnList"
              :key="idx"
              class="cpointer"
              @mousedown="p11_doClk(1,idx,row)">{{ row.vlabel }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row,idx) in tbData"
            :key="idx"
            :class="(idx===idTr || row.bbPicked)?'trOver':''"
            @mouseout="p11_trOut"
            @mouseover="p11_trOver(idx)"
            @mousedown="p11_doClk(2,idx,row)">
            <td class="tdIdx">{{ idx+1 }}</td>
            <td
              v-for="(mm,eidx) in tbClmnList"
              :key="eidx">
              <p v-if="mm.vvtype===13">
                <a class="aBlue" @click="p11_doClk(13,0,row)">{{ row[mm.vkey] }}</a><!---eClick(row,mm)-->
              </p>
              <div v-if="!comm.numIn(mm.vvtype,[13])">
                <!--fcode,link--->
                <a
                  v-if="mm.vkey==='fcode'"
                  @click="p02_toEdit(row)">
                  {{ row[mm.vkey] }}
                </a>
                <!--others--->
                <div
                  v-if="mm.vkey!=='fcode' && mm.vvtype!==16"
                  :class="mm.alignR?'txtR':''">
                  <c v-if="$keys().iDb === 'sabo' && mm.vkey==='last_time'">
                    <b v-show="row.fstat===0" style="color:rgb(190, 190, 190);font-size:17px">▼</b>
                    <b v-show="row.fstat===3" style="color:rgb(69, 173, 69);font-size:26px">●</b>
                    <b v-show="row.fstat===5" style="color:rgb(69, 173, 69);font-size:26px">●</b>
                    <b v-show="row.fstat===7" style="color:red;font-size:26px">●</b>
                    <b v-show="row.fstat===9" style="color:orange;font-size:26px">●</b>
                    <b v-show="row.fstat===11" style="color:blue;font-size:26px">●</b>
                  </c>
                  {{ row[mm.vkey] }}
                  <b v-if="mm.vvtype===17">%</b>
                </div>
                <!--img--->
                <img v-if="mm.vvtype===16" :src="p16_mkImg(row,mm.vkey)" class="imgList" @click="p16_ImgBig(row,mm.vkey)">
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr><!-- class="editTbFoot"-->
            <th>-</th>
            <th v-for="(row,idx) in tbClmnList" :key="idx"/>
          </tr>
        </tfoot>
      </table>
    </div>
    <!--BOX-->
    <div v-if="bbAdmin || p_menu.fidtype" ref="divBoxes" :style="[{'height':bbFull?'100%':(pHeight-210)+'px'},{'display':(!bbBox?'none':'')}]" class="divList">
      <div
        v-for="(row,idx) in tbData"
        :key="idx"
        :class="pkBoxClass(row)"
        @mouseout="p11_trOut"
        @mouseover="p11_trOver(idx)"
        @mousedown="p11_doClk(2,idx,row)">
        <p class="txtC txtB16 m2mm">{{ row.fname }}</p>
        <br>
        <p v-if="comm.numIn(p_menu.fidmenu,[6,16071])" class="txtC txtB16 m2mm">稼动率:{{ row.frate }}%</p>
        <p class="txtC mtb2mm">{{ row.fcode }}</p>
        <p class="txtC mtb2mm">{{ row.fnamecust }}</p>
        <p class="txtC mtb2mm">{{ row.fnamestat }}</p>
        <p class="txtC mtb2mm">{{ row.last_time }}</p>
        <p class="txtC p2px bkWhiteS cBlack w40pct">
          <i class="el-icon-location"/>
          {{ row.fcity }}
        </p>
      </div>
    </div>
    <!--编辑-->
    <CEdit
      v-if="bbEdit && $keys().iDb !== 'sabo'"
      :p_btns="btnEdit"
      :p_idmenu="p_menu.fidmenu"
      :p_colm_top="tbClmnEditTop"
      :p_colm_btm="tbClmnEditBtm"
      :p_colm_ey="tbClmnEditEy"
      :p_row="editRow"
      :p_entry="editEntry"
      :to-do="toAct"/>
    <CEquip
      v-if="bbEdit && $keys().iDb === 'sabo'"
      :p_btns="btnEdit"
      :p_url="p_menu.furl"
      :p_idmenu="p_menu.fidmenu"
      :p_colm_top="tbClmnEditTop"
      :p_row="editRow"
      :to-do="toAct"/>
    <!---大图--->
    <div v-if="bbImg" class="divPrts" @click="p16_ImgBig(false)">
      <img :src="editImg" class="divPrts">
    </div>
    <!--Full view-->
    <div class="stickR round50px txtC">
      <i
        v-if="bbBox && 1>2"
        class="el-icon-arrow-up"
        style="font-size: 28px;padding: 2px;color:rgba(100, 100, 245, 0.801);"
        @click="toAct(104)"/>
      <br>
      <i
        :class="bbBox?'el-icon-s-order':'el-icon-s-marketing'"
        style="font-size: 28px;padding: 2px;color:rgba(100, 100, 245, 0.801);"
        @click="toAct(102)"/>
      <br>
      <i
        :class="bbFull?'el-icon-c-scale-to-original':'el-icon-full-screen'"
        style="font-size: 28px;padding: 2px;color:rgba(100, 100, 245, 0.801);"
        @click="toAct(103)"/>
      <i
        v-if="bbBox && 1>2"
        class="el-icon-arrow-down"
        style="font-size: 28px;padding: 2px;color:rgba(100, 100, 245, 0.801);"
        @click="toAct(105)"/>
      <br>
    </div>
    <!---打印或取消--->
    <div v-if="bbPrint && iTypePrt<50" class="divPrts flexR">
      <div id="divPrt" class="divPrtsL">
        <print-01
          :p_row="prtRows[0]"
        />
      </div>

      <div class="divPrtsR">
        <p><button @click="p19_4_doPrt">打印</button></p>
        <p><button @click="toAct(36)">取消</button></p>
      </div>
    </div>
    <div v-if="bbPrint && iTypePrt>50" class="divPrts">
      <div id="divPrtBch" class="divPrtsL">
        <Prt21_4_batch
          v-if="iTypePrt===59"
          :prt-row="prtRows[0][0]"
          :prt-entry="prtRows[0]"
          :prt-sum="prtSums[0]"
        />
        <print-01
          :p_row="prtRows[0]"
        />
      </div>
      <div class="divPrtsR">
        <p><button @click="p51_prtBch">打印</button></p>
        <p><button @click="toAct(36)">取消</button></p>
      </div>
    </div>
    <!--文件导入-->
    <div>
      <input
        ref="iptFile"
        type="file"
        hidden
        capture="camera"
        @change="p14_readExl(2,1,$event)"><!--accept="image/jpeg,image/png,image/gif"-->
    </div>
    <!--<p>{{ iChange }}</p>-->
  </div>
</template>
<script type="text/javascript">
import CEdit from './02_edit.vue'
import CEquip from './12_equip.vue'
import MsgBox from './06_msgBox.vue'
import Print01 from './../c4_prt/p01_in.vue'
// import dateUtil from '../../utils/dateUtil'
import table2excel from 'js-table2excel'
import XLSX from 'xlsx'
import './../../../static/c_div.css'
import './../../../static/c_table.css'
import './../../../static/c_prt.css'
// import QRCode from 'qrcodejs2'
export default{
  name: 'CList',
  components: {
    MsgBox,
    CEdit,
    CEquip,
    Print01
  },
  props: {
    pHeight: {
      type: Number,
      default: 500
    },
    p_active: {
      type: Boolean,
      default: false
    },
    p_menu: {
      type: Object,
      default: () => {
        return {}
      }
    },
    toDo: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
      // iChange: 0,
      idTmExec: 0,
      idMenuEquip: 4, // 在线
      idTr: -1,
      idTrCk: -1,
      bbEdit: false,
      bbPrint: false,
      bbMsg: false,
      bbShowAll: false,
      bbLoading: false,
      bbReport: true,
      bbMore: false,
      bbInited: false,
      bbImg: false,
      bbBox: false,
      bbAdmin: false,
      bbFull: false,

      errMsg: '',
      ssMsgCancel: '',
      ssMsgOk: '',
      editId: 0,
      iTypePrt: 0,
      iAct: 0, // 16file
      iPiy: 0,

      vo: {},
      editRow: {},
      editImg: '',

      fdt1: '',
      fdt2: '',
      searchRow: {
        iAct: 21,
        fstat: 0
      },
      vFilter: {},
      colm: {},
      tbClmnList: [], // show in list
      tbClmnEditTop: [],
      tbClmnEditBtm: [],
      tbClmnEditEy: [],

      dtIdxList: [], // 日期列
      scdIdxList: [], // 秒，转时分秒
      sdtIdxList: [],
      btnIdxList: [], // 按键列
      amtIdxList: [], // 整数列
      ynIdxList: [], // yes no
      chkIdxList: [], // checkbox
      prcIdxList: [],
      cacuColList: [], // 计算列

      btnList: [],
      btnEdit: [],
      btnEditPk: [],

      finders: [],
      tbData: [],
      orgData: [],
      editEntry: [],
      origEditEntry: [],
      sumRow: {},
      options: {}, // {v1:[],v2:[]}

      dtNow: null,
      prtRowCnt: 10,
      prtRows: [],
      prtSums: [],
      divPrt: {
        id: 'divPrt',
        openCallback: () => {
        },
        clickMounted: () => {
        }
      }, // 打印按钮是对象时才用到
      vSort: ''
    }
  },
  watch: {
    p_active: {
      handler(newV, oldV) {
        if (newV && !this.vo.colms) {
          this.p01_getDs()
          setInterval(() => {
            this.p01_getDs()
          }, 360000)
        }
      },
      immediate: true// deep: true
    }
  },
  created: function() {
    // 报表this.bbReport = true
    this.prt('created.bbCust', localStorage.getItem('bbCust'))
    this.bbAdmin = (localStorage.getItem('bbCust') === 'false')
    this.prt('created.bbAdmin', this.bbAdmin)
  },
  methods: {
    prt(a, b) {
      console.log(`01_list.${a}`, b)
    },
    toAct(iAct/* 可以把这iAct去掉，认row里的*/, row) {
      this.prt('toAct.2', iAct)
      this.iAct = iAct
      if (this.comm.numIn(iAct, [1, 3])) this.toSave(row)// 保存 审核 出库
      if (iAct === 2) this.p02_toEdit()
      if (iAct === 4) this.p04_chkPrc()
      if (iAct === 6) this.p06_resetPwd()
      if (iAct === 9) this.p04_toMsg('确定删除?', '取消', '确定')
      if (iAct === 14) this.p14_readExl(1)
      if (iAct === 20) this.p04_toMsg('确定取消出库?', '取消', '确定')
      if (iAct === 25) this.p25_downTmp()
      if (iAct === 31) this.clsEdit()
      if (iAct === 32) this.p32_exportExl()
      if (iAct === 33) this.p04_toMsg(row, ' ', '确定')
      if (iAct === 36) this.bbPrint = false
      if (iAct === 10041) this.p37_svBatch()
      if (iAct === 40) this.p40_prt(1)// 打印
      // if (this.comm.numIn(iAct, [40, 41])) this.p40_prt(1)// 打印
      if (iAct === 38) this.bbMore = !this.bbMore
      if (iAct > 40 && iAct < 50) this.toPrint(iAct, row)// 打印
      if (iAct > 50 && iAct < 60) this.p50_prtBch(iAct)// 打印
      if (iAct === 61) this.p04_toMsg('确定重启设备?', '取消', '确定')
      if (this.comm.numIn(iAct, [71, 72, 73])) this.p70_fetchEqpInfo()
      if (iAct === 101) this.p01_getDs()
      if (iAct === 102) this.bbBox = !this.bbBox
      if (iAct === 103) {
        this.bbFull = !this.bbFull
        if (this.bbFull) {
          this.idTmExec = setInterval(() => {
            this.p01_getDs()
          }, 30000)
        } else {
          clearInterval(this.idTmExec)
        }
        this.toDo(103)
      }
      if (iAct === 104) this.p104_divScroll()
      if (iAct === 105) this.p104_divScroll(true)
      if (iAct === 1021) {
        this.bbAdmin = true
        this.p01_getDs()
      }
    },
    p01_getDs() {
      this.bbLoading = true
      this.dtNow = new Date()
      this.searchRow['fidmenu'] = this.p_menu.fidmenu
      this.searchRow['iAct'] = this.p_menu.iAct
      this.$iPost(this.p_menu.furl, this.searchRow).then(
        rs => {
          this.prt('p01_getDs.rs', rs)
          if (rs.status === 200 && rs.data) {
            this.vo = this.comm.mkColmns(rs.data.data)

            this.finders = this.vo.finders
            // this.tbData = this.vo.data// (clmnObj.data.slice(0, 2500))
            this.btnList = this.vo.btns.filter(row => { return row.vbox === 0 })
            this.btnEdit = this.vo.btns.filter(row => { return row.vey || row.vbox === 1 })

            this.tbClmnList = this.vo.colms.filter(row => { return !row.vhide /** && !row.vbox */ })
            this.prt('p01_getDs.vo', this.vo)
            this.tbClmnEditTop = this.vo.colms.filter(row => { return (!row.vbox || !this.comm.numIn(row.vbox, [1, 5/* 仓库 */, 7])) && row.vsort < 800 })
            this.tbClmnEditEy = this.vo.colms.filter(row => { return this.comm.numIn(row.vbox, [1, 5]) })
            this.tbClmnEditBtm = this.vo.colms.filter(row => { return (!row.vbox || !this.comm.numIn(row.vbox, [1, 7])) && row.vsort > 800 })

            if (this.$keys().iDb === 'sabo') {
              this.tbClmnList.forEach(row => {
                if (this.comm.ssIn(row.vkey, ['fworktimes', 'fruncycle']))row['alignR'] = true// 右对齐：压制总次数
              })
              const equipVO = require('../c5_vo/a.json')
              this.tbClmnEditTop = [...this.tbClmnEditTop, ...equipVO.colms]
              this.vo.colms = [...this.vo.colms, ...equipVO.colms]// 为了处理数据类型
            }
            this.p01_pkIndex()// *******特殊列的位置，如日期，数量等*******  //
            this.p01_mkDs()// if (rs.data && rs.data.length > 0)
            this.p02_filterDs()
            this.bbLoading = false
          } else {
            alert(rs.data.msg)
            this.bbLoading = false
          }
        }
      ).catch(rs => {
        this.tbData = []
        this.bbLoading = false
        alert(rs)
      })
    },
    p01_pkIndex() {
      this.prt('p01_pkIndex', 1)
      this.ynIdxList = []
      this.amtIdxList = []
      this.btnIdxList = []
      this.scdIdxList = []
      this.dtIdxList = []
      this.chkIdxList = []
      this.prcIdxList = []
      this.sdtIdxList = []
      this.cacuColList = []

      this.vo.colms.forEach((clmn, e) => {
        if (clmn.vvtype === 1) {
          this.amtIdxList.push(clmn.vkey)// 合计的数字，单价件数~
          if (clmn.vcaculate) this.cacuColList.push(clmn.vkey)
        }
        if (clmn.vvtype === 3) this.dtIdxList.push(clmn.vkey)
        if (clmn.vvtype === 7) this.ynIdxList.push(clmn.vkey)
        if (clmn.vvtype === 8) this.chkIdxList.push(clmn.vkey)
        if (this.comm.numIn(clmn.vvtype, [9, 17])) this.prcIdxList.push(clmn.vkey)// 不合计的数字，单价,比率
        if (clmn.vvtype === 11) this.sdtIdxList.push(clmn.vkey)// 短日期
        if (clmn.vvtype === 15) this.btnIdxList.push(clmn.vkey)// 按钮
        if (clmn.vvtype === 18) {
          this.scdIdxList.push(clmn.vkey)// 秒
        }
      })

      this.prt('p01_pkIndex', 2)
    },
    p01_mkDs() {
      const ids = []
      this.sumRow = {}
      const vSeconds = this.dtUtil.toSeconds(this.dtNow)
      this.vo.data.forEach(row => {
        const idx = ids.indexOf(row.fid)
        row['fide'] = this.bbShowAll ? 1 : (idx === -1 ? 1 : 0)
        ids.push(row.fid)
        if (this.$keys().iDb === 'sabo') {
          row['lastTm'] = this.dtUtil.dtDiff(row['last_time'], this.dtNow, 'ss')
          row['fworktimes'] = this.comm.toNumLocale(row['fworktimes'])
          // if (row['lastTm'] > 200)row.fnamestat = '离线'
          row['frate'] = row.ftm ? ((vSeconds - row.ftm) / vSeconds * 100).toFixed(2) : ''
          this.p01_mkStatEquip(row)
        } else {
          row.fnamestat = this.p01_mkStat(row)
        }
        this.dtIdxList.forEach(idex => {
          const newV = this.dtUtil.dateFmt(row[idex])
          row[idex] = newV
        })// 日期
        this.amtIdxList.forEach(colm => {
          const newV = row[colm] ? parseFloat(row[colm]).toFixed(2) : ''
          row[colm] = newV
          const qq = this.sumRow[colm] || 0
          this.sumRow[colm] = (parseFloat(qq) + parseFloat(newV === '' ? 0 : newV)).toFixed(2)
        })// 带合计的数字
        this.ynIdxList.forEach(colm => {
          // const newV = (row[colm] === '1' ? 'Y' : '')
          // row[colm] = newV
          row[colm] = (this.comm.toNum(row[colm]) === 1)// TODO:MSSQL是1\0; MYSQL?
        })// 是否
        this.scdIdxList.forEach(colm => {
          const seconds = this.comm.toNum(row[colm])
          let newV = ''
          let s2 = seconds
          let s3 = seconds
          if (seconds > 3600) {
            s2 = seconds % 3600
            newV = (seconds - s2) / 3600 + '时'
          }
          if (s2 > 60) {
            s3 = s2 % 60
            newV += (s2 - s3) / 60 + '分'
          }
          newV += s3 + '秒'
          row[colm] = newV
        })// 时间

        this.finders.forEach(vFind => {
          if (vFind.vfindtype && vFind.vfindtype > 10100 && vFind.vfindtype < 10200) {
            let list = this.options['v' + vFind.vfindtype]

            const vption = (row[vFind.vkey] ? row[vFind.vkey].trim() : '')
            if (!list) {
              list = [vption]
              this.options['v' + vFind.vfindtype] = list
            } else {
              const idx = list.findIndex(vey => { return vey === vption })
              if (idx === -1) list.push(vption)
            }
          }
        })
      })
      this.prt('p01_mkDs', 2)
      if (this.$keys().iDb === 'sabo') {
        if (this.p_menu.fidmenu === this.idMenuEquip) { // 在线设备
          this.vo.data = this.vo.data.filter(row => {
            return row['lastTm'] < 200 && row['lastTm'] > -1
          })
        }
      }
      this.prt('p01_mkDs', 3)
    },
    p01_mkStat(row) {
      const stat = this.comm.toNum(row.fstat)
      let statNm = ''
      if (stat === 1)statNm = '已审核'
      return statNm
    },
    p01_mkStatEquip(row) {
      // 0 离线 3连续运行中 5单次运行中 7错误 9已通电 11准备就绪
      if (row['lastTm'] > 200) {
        row.fstat = 0
        row.fnamestat = '离线'
      } else {
        if (row.fstatrun === 'true') {
          if (row.fstatcontinuous === 'true') {
            row.fstat = 3
            row.fnamestat = '连续运行'
          } else {
            row.fstat = 5
            row.fnamestat = '单次运行'
          }
        } else {
          if (this.comm.toNum(row.fstaterror) !== 0) {
            row.fstat = 7
            row.fnamestat = '异常'
          } else if (row.fstatinit === 'false') {
            row.fstat = 9
            row.fnamestat = '已通电'
          } else {
            row.fstat = 11
            row.fnamestat = '准备就绪'
          }
        }
      }
    },
    p02_filterDs() {
      this.prt('p02_filterDs.vFilter', this.vFilter)
      let ds = [...this.vo.data]
      for (var vfilt in this.vFilter) {
        if (this.comm.isVal(this.vFilter[vfilt])) {
          this.prt('p02_filterDs.vfilt', vfilt)
          ds = this.p02_filterDs2(ds, vfilt, this.vFilter[vfilt])
        }
      }
      this.tbData = ds
    },
    p02_filterDs2(data, key, val) {
      return data.filter(row => {
        return row[key].indexOf(val) > -1
      })
    },
    p02_toEdit(row) {
      this.prt('p02_toEdit', row)
      // this.mkEditBtn(this.btnEdit, row)
      if (!row) {
        this.editRow = {
          fid: 0,
          frob: 0,
          fidpaystyle: 0,
          fidsalestyle: 0,
          iChange: 0// edit页面要刷新时，改变它
        }
        this.editEntry = []
      } else {
        row.iChange = 0
        const entrys = []
        this.tbData.forEach(row2 => {
          if (row2.fid === row.fid) {
            const row3 = { ...row2 }
            entrys.push(row3)
          }
        })
        this.editEntry = entrys.sort(this.comm.sortArr('fidey', true))
        this.editRow = row
      }
      this.editRow['fidmenu'] = this.p_menu.fidmenu
      this.editRow['fcodelength'] = this.p_menu.fcodelength
      this.bbEdit = true
    },
    // 1保存 2新增 3复制 4审 5冲红 6 7 8 9删除 10 11分配1 12分配确认 13取消分配 14readExcel 15 16 17 18出库1 19出库2 20取消出库
    // 25模板 31关闭编辑 32导出 33toMsg 34toFile 35deltFile 36取消打印 37\10041 列表保存 38more 查询条件
    // 40备货打印 41销售打印 42 43 44样品打印 45其他出库 59批量-发货明细
    mkEditBtn(btns, row) { /*
      this.prt('mkEditBtn.1.btns', btns)
      this.prt('mkEditBtn.2.menu', this.p_menu)
      this.prt('mkEditBtn.3.row', row)*/
      this.btnEditPk = []
      if (!row) {
        if (this.p_menu.factedit) {
          this.btnEditPk.push(btns[0])// TODO:是否都有0
        }
        return
      }

      const btnTemp = JSON.parse(JSON.stringify(btns))// btns.slice(0)// [...btns]
      btnTemp.forEach(btn => {
        if (row.fstat === 0) { // 未审：编辑保存、审核、删除
          if (this.p_menu.factedit) {
            if (btn.act === 1) this.btnEditPk.push(btn)
          }
          if (row.fid > 0) {
            if (this.p_menu.factaudit && btn.act === 4) this.btnEditPk.push(btn)
            if (this.p_menu.factdelt && btn.act === 9) this.btnEditPk.push(btn)
          }
        } else { // 已审：反审、冲红、取消出库、打印
          if (this.p_menu.factedit && btn.act === 3) this.btnEditPk.push(btn)// 复制
          if (row.fstat === 1) {
            if (btn.act === 4) {
              if (this.p_menu.factunchk) {
                btn.name = '取消' + btn.name
                this.btnEditPk.push(btn)
              }
            } else if (btn.act === 5) {
              // if (this.p_menu.factset) this.btnEditPk.push(btn)// 分配,要有分配权
            } else if (btn.act === 19) {
              if (this.p_menu.fidmenu === 15) { // 出库界面
                if (row.frob === '1') {
                  this.btnEditPk.push(btn)// 红单出货 this.p_menu.facttrans &&
                }
              }
            }
          } else if (row.fstat >= 3 && row.fstat < 7) {
            if (btn.act === 19) {
              if (this.comm.numIn(this.p_menu.fidmenu, [15, 25])) this.btnEditPk.push(btn)// 出货 this.p_menu.facttrans &&
            }
            if (btn.act >= 40) {
              this.btnEditPk.push(btn)// 打印
            }
          } else { // 已出库完成
            if (btn.act === 20) {
              if (this.p_menu.fidmenu === 15) this.btnEditPk.push(btn)// 取消出货 this.p_menu.facttrans &&
            }
          }
        }
      })
    },
    clsEdit() {
      this.bbEdit = false
      if (this.p_menu.fidmenu === 22) this.toDo(31, this.p_menu.fidmenu)// 虚拟入库直接关闭list
    },
    p02_saveIC(rows) {
      const bbs = []
      const billNos = []
      rows.forEach((row, e) => {
        if (e === 0) return
        if (!this.comm.isVal(row[0])) return
        const idxNo = billNos.findIndex(rno => {
          return rno === row[0]
        })
        if (idxNo > -1) {
          bbs[idxNo].entrys.push(this.p02_mkIcEy(row))
        } else {
          billNos.push(row[0])
          bbs.push(this.p02_mkIc(row))
        }
      })
      if (bbs.length > 0) {
        this.$iPost(this.p_menu.furl + 'Bth', bbs).then(
          rs => {
            this.prt('toSave.ok', rs)
            this.p01_getDs()
          }
        ).catch(rs => {
          this.prt('toSave.error', rs)
        })
      }
    },
    p02_mkIc(row) {
      const ey = this.p02_mkIcEy(row)
      return {
        fidmenu: this.p_menu.fidmenu,
        fcode: row[0],
        fdate: this.dtUtil.dtFmt(row[1]), // dateUtil.dtFmt(row[1]),
        fnamecust: row[2],
        entrys: [ey]
      }
    },
    p02_mkIcEy(row) {
      return {
        fnameitem: row[3],
        fmodel: row[4],
        fnameunit: row[5],
        fprice: row[7],
        fqty: row[6],
        famount: row[8],
        fnotey: row[13]
      }
    },
    p04_toMsg(msg, ssCancel, ssOk, iiSecond) {
      this.bbMsg = true
      this.ssMsgCancel = ssCancel
      this.ssMsgOk = ssOk
      this.errMsg = msg
      if (iiSecond) {
        setTimeout(() => {
          this.bbMsg = false
        }, iiSecond)
      }
    },
    p04_doConfirm(bbOk) {
      this.prt('p04_doConfirm', bbOk)
      if (bbOk) {
        if (this.iAct === 9) {
          this.editRow.iAct = 9
          this.toSave(this.editRow)// 删除
        }
        if (this.iAct === 20) {
          this.editRow.iAct = 20
          this.editRow.fid = this.editRow.fidprt
          this.toSave(this.editRow)// 取消出库
        }
        if (this.iAct === 35) this.rmFile(2)
        else if (this.iAct === 61) this.p61_reboot()
      }
      this.bbMsg = false
    },
    p04_upStat() {
      this.editRow.iAct = 4
      this.editRow.fstat = (this.editRow.fstat === 0 ? 1 : 0)
      this.toSave(this.editRow)
    },
    p06_resetPwd() {
      this.editRow.iAct = 6
      this.toSave(this.editRow)
    },
    p11_trOver(idTr) {
      this.idTr = idTr
    },
    p11_trOut() {
      this.idTr = -1
    },
    p11_doClk(iType, idx, row, mm) { // iType:1.标题列 2.表格行变色 13.cell附件下载
      if (iType === 1) {
        this.prt('p11_doClk.' + idx, row.vvtype + ':' + row.vkey)
        this.tbData = this.tbData.sort(this.comm.arrSort(row.vvtype, row.vkey, !(this.vSort === row.vkey)))
        this.vSort = row.vkey
        // /this.iChange++
      }
      if (iType === 2)row.bbPicked = (!row.bbPicked)
      if (iType === 13) {
        const path = row.fidmenu + '/' + row.fidparent + '/' + row.fpath
        const url = this.$keys().mainUrl + '/login/down?name=' + row.filenm + '&path=' + path
        this.$dnFile(url, row.fname + '.' + row.filenm)
        // window.open(url, 'blank') // http://127.0.0.1:10091/11002/1/eventlog/EL_20240614.evt
      }
    },
    toSave(editRow) {
      this.prt('toSave', editRow)
      this.$iPost(this.p_menu.furl, editRow).then(
        rs => {
          this.prt('toSave.ok', rs)
          if (rs.status !== 200 || !rs.data) {
            this.errMsg = '保存失败.' + this.comm.pkErrMsg(rs.data.msg)
            alert(this.errMsg)
            return
          }
          // editRow.fid = rs.data.fid
          if (editRow.upFiles && editRow.upFiles.length > 0) {
            this.upFiles(editRow)
          }
          this.p04_toMsg('操作完成', '', '确定', 800)
          this.p01_getDs()
        }
      ).catch(rs => {
        this.prt('toSave.error', rs)
      })
    },
    upFiles(editRow) {
      this.bbLoading = true
      const frmData = new window.FormData()
      editRow.upFiles.forEach(row => {
        frmData.append('upFiles', row)
      })
      frmData.append('fidmenu', this.p_menu.fidmenu)
      frmData.append('fidparent', editRow.fid)
      return this.$upFile(this.$keys().urlUpFile, frmData)
    },
    p14_readExl(iStep, iType, evt) {
      // iStep: 1.选文件; 2.读
      // iType:1.批量入库
      if (iStep === 1) {
        this.$refs.iptFile.click()
      } else if (iStep === 2) {
        const my = this
        this.prt('p14_readExl.2.evt', evt)
        const iFile = evt.target.files[0]
        this.$refs.iptFile.value = null
        const reader = new FileReader()
        reader.onload = function(e) {
          const data = new Uint8Array(e.target.result)// 16进制数据
          const workbook = XLSX.read(data, { type: 'array', cellDates: true, codepage: 65001 })
          const result = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]],
            { header: 1, raw: true, dateNF: 'yyyy-mm-dd' })
          my.prt('p14_readExl.3.exl-json', result)// 这里已经能拿到转换后的json
          if (iType === 1) my.p02_saveIC(result)
        }
        reader.readAsArrayBuffer(iFile)
      }
    },
    p16_mkImg(row, key) {
      this.prt('p16_mkImg', key)
      return this.$keys().mainUrl + '/upload/' + this.p_menu.fidmenu + '/' + row.fid + '/' + row[key]
    },
    p16_ImgBig(row, key) {
      if (!row) this.bbImg = false
      else {
        this.editImg = this.$keys().mainUrl + '/upload/' + this.p_menu.fidmenu + '/' + row.fid + '/' + row[key]
        this.bbImg = true
      }
    },
    p25_downTmp() {
      const url = '../../../static/tmp/tem' + this.p_menu.fidmenu + '.xls'
      window.open(url, '_blank')
    },
    p32_exportExl() {
      const colms = []
      const datas = []
      this.vo.colms.forEach(row => {
        colms.push({ title: row.label, key: row.value, type: 'text' })
      })
      this.orgData.forEach(row => {
        const row2 = { ...row }
        // row2['身份证'] = '\'' + row2['身份证']
        // row2['银行卡'] = '\'' + row2['银行卡']
        if (row.fid)datas.push(row2)
      })
      table2excel(colms, datas, this.p_menu.fnamemenu)
    },
    p40_prt(iAct) {
      this.iTypePrt = iAct
      this.bbPrint = true
      this.prt('p40_prt.1', this.editEntry)

      const sumObj = {}
      this.editEntry.forEach(row => {
        this.amtIdxList.forEach(colNm => {
          if (!row[colNm]) return
          // this.prt('toPrtSum,3.' + colNm, row)
          const newV = this.comm.toNum(row[colNm])
          row[colNm] = newV
          const qq = sumObj[colNm] || 0
          sumObj[colNm] = (parseFloat(qq) + this.comm.toNum(newV)).toFixed(4)
          this.prt('p40_prt,4', sumObj)
        })// 数字
      })
      this.prtSums.push(sumObj)
    },
    p41_mkPrtRow(row) {
      const prtRow = { ...this.editRow, ...row }
      const entry = []
      // this.prt('p41_mkPrtRow.1', row)
      // this.prt('p41_mkPrtRow.2', this.origEditEntry)
      row.entrys.forEach(rowey => {
        this.origEditEntry.forEach(rowey2 => {
          if (rowey.fiditem === rowey2.fiditem) {
            const newRow = { ...rowey2, ...rowey }
            if (newRow.fpqbox) {
              const fpqbox = parseInt(newRow.fpqbox)
              newRow.fqleft = newRow.fqty % fpqbox// fqtyprt
              newRow.fqbox = (newRow.fqty - (newRow.fqty % fpqbox)) / fpqbox
              if (newRow.fpqsquare) newRow.fqsquare = (newRow.fqbox * newRow.fpqsquare).toFixed(4)
              if (newRow.fpqweight) newRow.fqweight = (newRow.fqbox * newRow.fpqweight).toFixed(4)
            }
            entry.push(newRow)
          }
        })
      })
      prtRow['entrys'] = entry
      // this.prt('p41_mkPrtRow.prtRow', prtRow)
      return prtRow
    },
    toPrint(iType, prtRow) { // fortest:X231123-0008
      this.prt('toPrint. 1', prtRow)
      this.iTypePrt = iType
      const prtObj = this.editRow
      prtObj['entrys'] = this.editEntry.filter(row => { return row.fid > 0 })
      this.prtRows = [prtObj]
      this.editEntry.forEach(row1 => {
      })
      this.bbPrint = true
      /*
      setTimeout(() => {
        this.$refs.divPrt.click()// $('#divPrt').jqprint()
      }, 1000)
      setTimeout(() => {
        this.bbPrint = false
      }, 5000)*/
    },
    p50_prtBch(iType) {
      this.iTypePrt = iType
      const ids = []
      const list = []
      this.tbData.forEach(row => {
        if (row.bbPicked)ids.push(row.fid)
        if (row.bbPicked || ids.indexOf(row.fid) > -1) {
          list.push(row)
        }
      })
      this.prtRows = [list]
      this.prt('p50_prtBch.' + this.iTypePrt, this.prtRows)
      this.bbPrint = true
      setTimeout(() => {
        this.toPrtSum()
      }, 1000)
    },
    p51_prtBch() {
      this.$refs.divPrtBch.click()
      setTimeout(() => {
        this.bbPrint = false
      }, 3000)
    },
    toPrtSum() {
      this.prt('toPrtSum,amtIdxList', this.amtIdxList)
      const my = this
      this.prtSums = []
      this.prtRows.forEach(row1 => {
        const sumObj = {}
        row1.forEach(row => {
          my.amtIdxList.forEach(colNm => {
            if (!row[colNm]) return
            // this.prt('toPrtSum,3.' + colNm, row)
            const newV = this.comm.toNum(row[colNm])
            row[colNm] = newV
            const qq = sumObj[colNm] || 0
            sumObj[colNm] = (parseFloat(qq) + this.comm.toNum(newV)).toFixed(4)
            // this.prt('toPrtSum,4', sumObj)
          })// 数字
        })
        my.prtSums.push(sumObj)
      })
      this.prt('toPrtSum.2', this.prtSums)
    },
    p19_4_doPrt() {
      this.$refs.divPrt.click()
      this.editRow.iAct = this.iAct > 40 ? 41 : 40// TODO:未考虑调拨~
      this.toSave(this.editRow)
      setTimeout(() => {
        this.bbPrint = false
      }, 3000)
    },
    p19_6_fillRow(row) {
      const cnt = this.prtRowCnt - row.length
      if (cnt > 0) {
        for (var i = 1; i <= cnt; i++) {
          row.push({ fid: i })
        }
      }
      return row
    },
    p26_rowClick(row) {
      this.prt('p26_rowClick.1', row)
      this.prt('p26_rowClick.2', this.tbData)
      if (row.iAct > 0) this.p11_toSet(row.iAct, row.fid, row.fcode, row.fstat)
    },
    p91_hChg(iAct, idx, obj, evnt) { // hChg(7,2,row,$event)
      this.prt('p91_hChg.1', obj)
      this.prt('p91_hChg.2', evnt)
      if (iAct === 3) {
        if (!evnt) {
          this.searchRow[obj.value + idx] = ''
        }
        this.prt('p91_hChg.3', this.searchRow)
        this.iPiy++
      }
    },
    p61_reboot() {
      this.editRow.iAct = 61
      this.editRow.equipCmd = 'reboot'
      this.toSave(this.editRow)
    },
    p70_fetchEqpInfo() {
      this.bbLoading = true
      this.$iPost('equip/fetchLog', { iAct: this.iAct }).then(
        rs => {
          this.prt('equip/fetchLog', rs)
          this.p01_getDs()
        }
      ).catch(rs => {
        this.bbLoading = false
        this.prt('toSave.error', rs)
      })
    },
    pkBoxClass(row) {
      let vCss = 'box3_5 '// 0 离线 3连续运行中 5单次运行中 7错误 9已通电 11准备就绪
      if (this.comm.numIn(this.p_menu.fidmenu, [6, 16071])/* 稼动率*/) {
        if (row.fstat === 11 && 1 > 2) {
          vCss += 'bkGrayX'
        } else {
          if (row.frate >= 75)vCss += 'bkGreenX'
          else if (row.frate >= 50)vCss += 'bkBlueX'
          else if (row.frate >= 30)vCss += 'bkGrayX'
          else vCss += 'bkRedX'// 'bkGrayX'//
        }
      } else {
        if (row.fstat === 0)vCss += 'bkGrayX'/*
        else if (row.fstat === 3)vCss += 'bkGreenX'
        else if (row.fstat === 5)vCss += 'bkGreenX'*/
        else if (this.comm.numIn(row.fstat, [3, 5])) {
          if (row.fruncycle < 10)vCss += 'bkGreenX1'
          else if (row.fruncycle < 15)vCss += 'bkGreenX2'
          else vCss += 'bkGreenX3'
        } else if (row.fstat === 7)vCss += 'bkRedX'
        else if (row.fstat === 9)vCss += 'bkOrangeX'
        else if (row.fstat === 11)vCss += 'bkBlueX'
      }
      return vCss
    },
    p104_divScroll(bbUp) {
      // const vHeight = this.$refs.divBoxes.scrollHeight
      const vTop = this.comm.toNum(this.$refs.divBoxes.scrollTop)
      this.prt('p104_divScroll.top', vTop)
      if (bbUp) {
        this.$refs.divBoxes.scrollTop = vTop + 100
      } else {
        this.$refs.divBoxes.scrollTop = vTop - 100
      }
    }
  }
}
</script>
<style scoped>
.iptChk{
  width: 15px;
}
.divBts{
  padding: 6px 0 0 20px;
  display: flex inline;
  flex-direction: row;
  text-align: center;
  float: left;
}
.divBts a{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/comps/c2_info/01_list.vue